import {SDrawerOrModal, SGeneralForms, SMessage} from "shj-components";
import {Space, Input, Button, Form, message} from "antd";
import {useSetState} from "ahooks";
import {ChooseCustomer} from "../components/ChooseCustomer";
import {useEffect} from "react";
import {isEmpty} from "lodash-es";
import dayjs from "dayjs";
import {addMeasurePerson, getMeasureRoomList} from "@/services/crmTool.ts";

interface IAddOrEditProps {
  open?: boolean
  title?: string
  reload?: (values?: object, res?: any) => void
  onClose?: (values?: object) => void
  record?: any
}


export const AddReservationCustomerModal: React.FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const {open, onClose, reload} = props
  const [form] = Form.useForm()

  const [state, setState] = useSetState<any>({
    open: false,
    customerInfo: {},
    loading: false,
  })

  useEffect(() => {
    form.resetFields()
    return () => {
      setState({customerInfo: {}})
      form.setFieldsValue({})
    }
  }, [open]);

  const onSubmit = () => {
    form.validateFields().then(values => {
      setState({loading: true})
      const newValues = {
        trackPlanId: state.customerInfo.id,
        appointmentTime: dayjs(values.appointmentTime).format('YYYY-MM-DD HH:mm:ss'),
        remark: values.remark
      }
      getMeasureRoomList({
        trackPlanId: state.customerInfo.id,
        statusList: ['measured', 'auditing', 'completed']
      }).then(res => {
        if (res.length > 0) {
          SMessage.confirm({
            title: '该商机已经完成量房，是否还需要二次预约量房服务？',
            content: null,
            onOk: () => {
              return onAddFn(newValues)
            }
          })
        } else {
          onAddFn(newValues)
        }
      }).finally(() => {
        setState({loading: false})
      })
    })
  }

  const onAddFn = (newValues) => {
    addMeasurePerson(newValues).then(res => {
      message.success(res.message || '操作成功')
      onClose?.()
      reload?.()
    }).finally(() => {
      setState({loading: false})
    })
  }

  const onChangeCustomer = (info) => {
    form.resetFields(['name', "buildingName", 'bizTypeName', 'doorNo', 'houseNatureName', 'handoverDate'])
    setState({customerInfo: info})
    form.setFieldsValue(info)
  }

  return <>
    <SDrawerOrModal
        open={open}
        mode={'drawer'}
        title={'新增量房客户'}
        width={600}
        onCancel={onClose}
        onOk={onSubmit}
        loading={state.loading}
    >
      <SGeneralForms
          formConfig={{form}}
          layout={'vertical'}
          configs={[{
            formItem: [
              {
                spanCol: 12, label: '客户', name: 'name',
                children: <Space.Compact style={{width: '100%'}}>
                  <Input value={state.customerInfo?.name} disabled placeholder={'请选择客户'}/>
                  <Button type="primary" onClick={() => setState({open: true})}>选择</Button>
                </Space.Compact>
              },
              {
                spanCol: 12, label: '楼盘', name: 'buildingName',
                comConfig: {
                  disabled: true,
                }
              },
              {
                spanCol: 12, label: '需求标签', name: 'bizTypeName',
                comConfig: {
                  disabled: true,
                }
              },
              {
                spanCol: 12, label: '门牌号', name: 'doorNo',
                comConfig: {
                  disabled: true,
                }
              },
              {
                spanCol: 12, label: '房屋属性', name: 'houseNatureName',
                comConfig: {
                  disabled: true,
                }
              },
              {
                spanCol: 12, label: '交房时间', name: 'handoverDate',
                type: 'date',
                comConfig: {
                  disabled: true,
                }
              },
              {
                spanCol: 24,
                label: '预约量房时间',
                name: 'appointmentTime',
                type: 'dateTime',
                required: true,
                rules: [{required: true, message: '不能为空'}],
                comConfig: {
                  disabledDate: current => current && current < dayjs().subtract(1, 'day')
                }
              },
              {spanCol: 24, label: '备注', name: 'remark',},
            ]
          }]}/>
      <ChooseCustomer open={state.open} onClose={() => setState({open: false})} fn={onChangeCustomer}/>
    </SDrawerOrModal>
  </>

}